import { ROLES } from "../../../helpers/commons.helpers";

/**
 * Notification route definitions.
 *
 * These routes are lazy-loaded and intended to be used as children of the
 * authenticated layout. Each route exposes a `meta` object with common
 * properties used by navigation guards and permission checks.
 *
 * @typedef {Object} NotificationRouteMeta
 * @property {Array<string>} modules - Application module keys related to the route.
 * @property {boolean} requiresAuth - When true the route requires an authenticated session.
 * @property {Array<string>} roles - Array of role identifiers allowed to access the route.
 *
 * @type {Array<import('vue-router').RouteConfig>}
 */
export default [
    {
        path: "/notifications",
        name: "Notifications",
        meta: {
            title: "Notifications",
            modules: ["notifications"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN]
        },
        component: () =>
            import(/* webpackChunkName: "notifications" */ "@/modules/notifications/pages/Notifications")
    }
]